<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'coupon_external_list'}" class="float-left mr-1 main-link">{{$t('coupon.child_coupon')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('coupon.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.parent_coupon')}}</legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.parentObj"
                        v-bind:placeholder="$t('coupon.parent_coupon')"
                        label="text" track-by="value"
                        @input="parentChange()"
                        :options="customCouponParentData"
                                   v-bind:selectLabel = "$t('menu.select_label')"
                                   v-bind:deselectLabel = "$t('menu.select_remove')"
                                   v-bind:selectedLabel = "$t('menu.selected')"
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.child_coupon_code')}}</legend>
                    <div class="col-sm-10" v-if="getCouponConfigByType('show', 'external_coupon_upload')">
                      <div v-if="id == undefined || id == 'create'" class="form-group row">
                        <div class="col-sm-3">
                          <b-form-select
                            v-model="item.couponCodeType"
                          >
                            <option value="input">{{ $t('coupon.manual_input') }}</option>
                            <option value="file">{{ $t('coupon.upload_file') }}</option>
                          </b-form-select>
                        </div>
                        <div class="col-sm-9">
                          <b-form-input v-if="item.couponCodeType=='input'" class="form-control" v-model="item.code"
                            v-bind:placeholder="$t('coupon.child_coupon_code')"
                            aria-describedby="code-feedback" :state="!$v.item.code.$invalid"/>
                          <b-form-invalid-feedback v-if="item.couponCodeType=='input'" :id="'coupon-code-feedback'">
                            <p class="help is-danger" v-if="!$v.item.code.required">{{ $t('message.required_filed') }}</p>
                            <p class="help is-danger" v-else-if="!$v.item.code.maxLength">{{ $t('coupon.coupon') }} {{ $t('coupon.coupon_max') }} {{$v.item.code.$params.maxLength.max}} {{ $t('coupon_character') }}.</p>
                            <p class="help is-danger" v-else-if="!$v.item.code.codeRegex">{{ $t(isJapanMarket() ? 'jp_code_regex_validation' : 'code_regex_validation') }}.</p>
                          </b-form-invalid-feedback>

                          <div  v-if="item.couponCodeType=='file' && !item.codeFile" style="padding-left: 0px;">
                            <label class="file-select">
                              <div class="select-button">
                                <span class="upload-icon"></span>
                                <span class="upload-text">{{$t('coupon.choose_coupon_csv')}}</span>
                              </div>
                              <input type="file" accept=".csv" @change="uploadCouponCodes"/>
                            </label>
                          </div>
                          <div v-if="item.couponCodeType=='file' && item.codeFile" class="coupon-file-path" >
                            <i class="file-icon"></i>
                            <span v-bind:class="[isUploadCouponCSVError ? 'file-upload-text error-upload' :'file-upload-text']">{{item.codeFileName}}</span>
                            <b-button class="delete-csv"variant="danger" v-on:click="removeCouponCodesFile()" size="sm"><i class="remove-icon"></i></b-button>
                          </div>
                          <div v-if="item.couponCodeType=='file'" class="form-group row">
                           <div v-if="'ja' === this.$session.get('lang')" class="col-sm-12">
                              <a :href="csvFileUrl">{{ $t('coupon.example_coupon_file') }}</a>
                              {{ $t('coupon.example_download_file') }}
                            </div>
                            <div v-else class="col-sm-12">
                              {{ $t('coupon.example_download_file') }}
                              <a :href="csvFileUrl">{{ $t('coupon.example_coupon_file') }}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <b-form-input class="form-control" v-model="item.code"
                          v-bind:placeholder="$t('coupon.child_coupon_code')"
                          aria-describedby="code-feedback" :state="!$v.item.code.$invalid"/>
                        <b-form-invalid-feedback :id="'coupon-code-feedback'">
                          <p class="help is-danger" v-if="!$v.item.code.required">{{ $t('message.required_filed') }}</p>
                          <p class="help is-danger" v-else-if="!$v.item.code.maxLength">{{ $t('coupon.coupon') }} {{ $t('coupon.coupon_max') }} {{$v.item.code.$params.maxLength.max}} {{ $t('coupon_character') }}.</p>
                          <p class="help is-danger" v-else-if="!$v.item.code.codeRegex">{{ $t(isJapanMarket() ? 'jp_code_regex_validation' : 'code_regex_validation') }}.</p>
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-sm-10" v-else>
                      <b-form-input v-if="id == undefined || id == 'create'" class="form-control" v-model="item.code"
                                    v-bind:placeholder="$t('coupon.child_coupon_code')"
                                    aria-describedby="code-feedback" :state="!$v.item.code.$invalid"/>
                      <b-form-input class="form-control" v-else v-model="item.code"
                                    v-bind:placeholder="$t('coupon.child_coupon_code')"
                                    aria-describedby="code-feedback" :state="!$v.item.code.$invalid"/>
                      <b-form-invalid-feedback :id="'coupon-code-feedback'">
                        <p class="help is-danger" v-if="!$v.item.code.required">{{ $t('message.required_filed') }}</p>
                        <p class="help is-danger" v-else-if="!$v.item.code.maxLength">{{ $t('coupon.coupon') }} {{ $t('coupon.coupon_max') }} {{$v.item.code.$params.maxLength.max}} {{ $t('coupon_character') }}.</p>
                        <p class="help is-danger" v-else-if="!$v.item.code.codeRegex">{{ $t(isJapanMarket() ? 'jp_code_regex_validation' : 'code_regex_validation') }}.</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :change="updateCrmURL()"
                        :name="`name[${lang}]`" />
                    </div>
                  </div>

                  <div class="form-group row margin-top20">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.description') }}
                    </legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-textarea class="form-control" v-model="item.content[lang]"
                      :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_'+lang)">
                      </b-form-textarea>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.number_of_coupon')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.quantity"
                        v-bind:placeholder="$t('coupon.number_of_coupon')" :state="!$v.item.quantity.$invalid"
                        aria-describedby="number_of_coupon-feedback"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.number_of_coupon_per_customer')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.quantity_per_customer"
                        v-bind:placeholder="$t('coupon.number_of_coupon_per_customer')" :state="!$v.item.quantity_per_customer.$invalid"
                        aria-describedby="number_of_coupon-feedback"/>
                        <i v-if="item.quantity_per_customer === '0'" class="text-danger">{{ $t('warning_message_quantity_per_customer_unlimited_usage') }}</i>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.applicable_store') }}
                    </legend>
                    <div class="col-sm-10 applicable-store ">
                      <multiselect
                          v-model="item.outlet_group_uuid"
                          track-by="value"
                          label="text"
                          :multiple="true"
                          :options="outletGroupsList"
                          :placeholder="$t('coupon.select_outlet_group')"
                          v-bind:selectLabel = "$t('coupon.select_label')"
                          v-bind:deselectLabel = "$t('coupon.select_remove')"
                          v-bind:selectedLabel = "$t('coupon.selected')"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">

                    </legend>
                    <div class="col-sm-10 applicable-store ">
                      <div>
                        <label class="file-select">
                          <div class="select-button">
                            <span class="upload-icon"></span>
                            <span class="upload-text">{{$t('coupon.choose_store_csv')}}</span>
                          </div>
                          <input type="file" @change="uploadStores"/>
                        </label>
                      </div>
                      <div v-if="item.validate_store_name && item.validate_store_name!=''" class="store-file-path">
                        <i class="file-icon"></i>
                        <a :href="item.validate_store_url" target="_blank" class="file-upload-text" style="word-break: break-all;" >{{item.validate_store_name}}</a>
                        <b-button class="delete-csv" v-if="item.validate_store_name" variant="danger" v-on:click="removeStoreUrl(item.validate_store_name)" size="sm"><i class="remove-icon"></i></b-button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                    </legend>
                    <div v-if="'ja' === this.$session.get('lang')" class="col-sm-10">
                      <a :href="store_url">{{ $t('coupon.example_store_file') }}</a>
                      {{ $t('coupon.example_download_file') }}
                     </div>
                    <div v-else class="col-sm-10">
                      {{ $t('coupon.example_download_file') }}
                      <a :href="store_url">{{ $t('coupon.example_store_file') }}</a>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.exclude_outlet') }}
                    </legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.exclude_outlet_list"
                        v-bind:placeholder="$t('coupon.exclude_outlet')"
                        label="text" track-by="value"
                        :multiple="true"
                        :options="outletsList"
                        :taggable="true"
                                   v-bind:selectLabel = "$t('menu.select_label')"
                                   v-bind:deselectLabel = "$t('menu.select_remove')"
                                   v-bind:selectedLabel = "$t('menu.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <div class="form-group row" v-if="getCouponConfigByType('show', 'ges_coupon_flag')">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.ges_coupon_flag') }}
                    </legend>
                    <div class="col-sm-10 switch-is-ges">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                          :pill="true" v-model="item.is_ges" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <!-- Time settings -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.time_settings') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateTimeSettingStatus"  v-b-toggle.time_settings_content>
                <i class="fa fa-sort-down" v-if="timeSettingStatus"></i>
                <i class="fa fa-sort-up" v-if="!timeSettingStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="timeSettingStatus" id="time_settings_content">
              <b-form class="row">
                <b-col cols="12">

                  <div :class="(!$v.item.active_start_date.validDate || !$v.item.active_end_date.validDate ? 'mb-0' : '') + 'form-group row '">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.active_period')}}</legend>
                    <div class="col-sm-3">
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.active_start_date.$invalid ? 'error' : ''"
                        :change="(e) => item.active_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.active_end_date.$invalid ? 'error' : ''"
                        :change="(e) => item.active_end_date = e"
                      />
                    </div>
                  </div>
                  <div class="form-group row" v-if="!$v.item.active_start_date.validDate || !$v.item.active_end_date.validDate">
                    <legend class="col-sm-2"></legend>
                    <b-form-invalid-feedback class="col-sm-10 d-block" :id="'active-period-feedback'">
                      <p class="help is-danger mb-0">{{$t('invalid_period_time_range')}}</p>
                    </b-form-invalid-feedback>
                  </div>

                  <div :class="(!$v.item.apply_start_date.validDate || !$v.item.apply_end_date.validDate ? 'mb-0' : '') + 'form-group row '">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_period')}}</legend>
                    <div class="col-sm-3">
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.apply_start_date.$invalid ? 'error' : ''"
                        :change="(e) => item.apply_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.apply_end_date.$invalid ? 'error' : ''"
                        :change="(e) => item.apply_end_date = e"
                      />
                    </div>
                  </div>
                  <div class="form-group row" v-if="!$v.item.apply_start_date.validDate || !$v.item.apply_end_date.validDate">
                    <legend class="col-sm-2"></legend>
                    <b-form-invalid-feedback class="col-sm-10 d-block" :id="'apply-period-feedback'">
                      <p class="help is-danger mb-0">{{$t('invalid_period_time_range')}}</p>
                    </b-form-invalid-feedback>
                  </div>

                  <div v-if="displayCrmURL()" class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.crm_url')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input
                        class="form-control"
                        v-model="item.crm_url"
                        :readonly="true"
                        v-bind:placeholder="$t('coupon.crm_url')"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_active_date_for_user')}}</legend>
                    <div class="col-sm-2" style="display: inline-flex;">
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.applicable_active_date_for_user"/>
                        <span style="margin-left: 10px; margin-top: 5px">{{$t('coupon.day_s')}}</span>
                    </div>
                  </div>


                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.enable_coupon_link') }}
                    </legend>
                    <div class="col-sm-10 switch-enable-link">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                          :pill="true" v-model="item.enable_link" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Time settings -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'coupon_external_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="activeSubmitBtn($v.item.$invalid)" variant="success" v-on:click="saveCoupon()">&nbsp; {{ $t('common.save')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required,requiredIf,maxLength,between } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import Multiselect from 'vue-multiselect'
import DatePickerInput from '@/components/Partials/DatePickerInput'

const VALIDATION_SUCCESS = 1
const VALIDATION_SEVERAL_FAILED = 2
const VALIDATION_ALL_FAILED = 3
let vm = null

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    MaskedInput,
    Multiselect,
    cSwitch,
    DatePickerInput
  },
  data: function () {
    return {
      coupon: this.$store.getters.config.gms.coupon,
      itemLimit: 10000,
      clientID: localStorage.getItem('clientID'),
      couponParentData:{},
      customCouponParentData:[],
      isLoadingCouponParent: false,
      isLoadingCoupon: false,
      isProcessing: false,
      prefix_crm_url: this.$store.getters.config.main.base_site_url,
      outletGroups:{},
      outletGroupsList:[],
      outlets:{},
      outletsList:[],
      store_url: "",
      csvFileUrl: "",
      item: {
        couponCodeType: 'input',
        coupon_id: "",
        parentObj: "",
        code:"",
        codeFileName: "",
        codeFile: "",
        name:{},
        content:{},
        quantity:999999999,
        sequence: 0,
        quantity_per_customer:1,
        active:1,
        active_start_date:this.$moment().format('DD-MM-YYYY'),
        active_end_date:'31-12-9999',
        apply_start_date:this.$moment().format('DD-MM-YYYY'),
        apply_end_date:'31-12-9999',
        crm_url: "",
        applicable_active_date_for_user: 0,
        outlet_group_uuid:"",
        validate_store_url: "",
        validate_store_name: "",
        exclude_outlet_list: "",
        enable_link: 0,
        is_ges: 0
      },
      basicInformationStatus: true,
      timeSettingStatus: true,
      languages: Object.keys(this.$i18n.messages),
      isLoadingOutletGroup: false,
      isLoadingOutlet: false,
      isUploadCouponCSVError: false,
    }
  },
  mixins: [
    validationMixin
  ],
  computed: {
    rules() {
      return {
        code: vm.item.couponCodeType === 'input' ? {
          required,
          maxLength: maxLength(50),
          codeRegex(code) {
            return this.validateCouponRegex(code)
          }
        } : {},
        sequence: {
          required,
          between: between(0, 999999999)
        },
        coupon_id:{
          required
        },
        quantity: {
          required,
          between: between(0, 999999999)
        },
        quantity_per_customer: {
          required,
          between: between(0, 999999999)
        },
        active_start_date: {
          validDate(active_start_date) {
            return this.validateDatetimeRange(active_start_date, this.item.active_end_date)
          }
        },
        active_end_date: {
          validDate(active_end_date) {
            return this.validateDatetimeRange(this.item.active_start_date, active_end_date)
          }
        },
        apply_start_date: {
          validDate(apply_start_date) {
            return this.validateDatetimeRange(apply_start_date, this.item.apply_end_date)
          }
        },
        apply_end_date: {
          validDate(apply_end_date) {
            return this.validateDatetimeRange(this.item.apply_start_date, apply_end_date)
          }
        },
      }
    }
  },
  validations() {
    return {
      item: this.rules
    }
  },
  methods: {
    activeSubmitBtn(disable) {
      if (vm.item.couponCodeType === 'input' || !vm.item.couponCodeType) {
          if (vm.item.code == null || vm.item.code == '') {
              return true;
          }
      } else {
          if (vm.item.codeFile == null || vm.item.codeFile == '') {
              return true;
          }
      }

      return disable;
    },
    getOutlets(){
      vm.isLoadingOutlet = true
      let params = 'disposition=all&language=all'
      vm.axios.coupon.getOutlets(params, function(response){
        let data=response.data.data.items
        if(!data) return
        let langs = vm.languages
        for (let l in langs) {
          vm.outlets[langs[l]] = []
          for (let c in data) {
            let item = data[c]
            if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
              vm.outlets[langs[l]].push({
                  value: item['code'],
                  text: item['code']+ ' - ' +item['name'][langs[l]]
              })
            }
          }
        }
        vm.$forceUpdate('outlets')
        vm.isLoadingOutlet = false
      })
    },
    getOutletGroups(){
      vm.isLoadingOutletGroup = true
      let params = 'fields=uuid,name&active=1&limit=9999999'
      vm.axios.coupon.getListOutletGroup(params, function(response) {
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.outletGroups[lang] = []
          for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][lang] != undefined && item['name'][lang] != '') {
                  vm.outletGroups[lang].push({
                      value:  item['uuid'],
                      text:   item['name'][lang],
                  })
              }
          }
        }
        vm.$forceUpdate('outletGroups')
        vm.isLoadingOutletGroup = false
      })
    },
    uploadStores (event) {
      let input = event.target
      vm.$bus.$emit('loading', 'block')
      if (input.files && input.files[0]) {
        let formData = new FormData();
        formData.append('file', input.files[0]);
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        //call an API to save csv file
        vm.axios.coupon.validateOutletList(formData, config, function(response){
          if (response.data.data.item.status != VALIDATION_ALL_FAILED) {
            vm.item.upload_store_url = response.data.data.item.name
            let name = response.data.data.item.name.split('/')
            vm.item.validate_store_name = name[name.length-1]
            vm.item.validate_store_url = response.data.data.item.file

            if (response.data.data.item.status == VALIDATION_SUCCESS) {
              vm.$toastr.success(vm.$t('message.upload_csv_success', vm.$session.get('lang')), vm.$t('message.success'), {})
            } else {
              vm.$toastr.success(vm.$t('message.upload_csv_success', vm.$session.get('lang')), vm.$t('message.success'), {})
            }
          } else {
            vm.$toastr.error(vm.$t('message.upload_csv_failed', vm.$session.get('lang')), vm.$t('message.error'), {})
          }
          vm.$bus.$emit('loading', 'none')
        }, function(error){
          vm.$bus.$emit('loading', 'none')
        })
      }
    },
    uploadCouponCodes (event) {
      const csvFilePattern = /^.+\.(csv)$/
      const input = event.target
      if (input.files && input.files[0]) {
        const file = input.files[0]
        const vm = this
        vm.isUploadCouponCSVError = false

        if (!csvFilePattern.test(file.name)) {
          vm.isUploadCouponCSVError = true
          vm.$toastr.error(vm.$t('message.upload_csv_fail_wrong_format'), vm.$t('message.error'), {})
        } else {
          this.item.codeFile = file
          this.item.codeFileName = this.item.codeFile.name
        }
      }
    },
    removeCouponCodesFile () {
      this.item.codeFile = ''
    },
    removeStoreUrl (name) {
      vm.$bus.$emit('loading', 'block')
      let params = 'type=store&name='+name
      vm.axios.coupon.removeCsvFile(params, function(response){
        vm.item.validate_store_name = ''
        vm.item.validate_store_url = ''
        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    getExampleURL () {
      vm.axios.coupon.getExampleFile(function(response){
        vm.store_url = response.data.data.item.store
        vm.csvFileUrl = response.data.data.item.child_coupon
      })
    },
    escapeRegExp (string) {
      return string.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s%,]/gm, '')
    },
    updateCrmURL () {
      vm.item.crm_url = vm.prefix_crm_url + '/crm/coupon/' + vm.item.code
    },
    parentChange () {
      if (vm.item.parentObj) {
        vm.item.coupon_id = vm.item.parentObj.value
      } else {
        vm.item.coupon_id = vm.item.parentObj
      }
    },
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    updateTimeSettingStatus () {
      this.timeSettingStatus = this.timeSettingStatus?false:true
    },
    displayCrmURL() {
      const vm = this;
      if (vm.id == undefined || vm.id == 'create') {
        return vm.item.couponCodeType == 'input'
      }
      return true
    },
    saveCoupon () {
      vm.$bus.$emit('loading', 'block')
      vm.isProcessing = true;

      const formData = new FormData()
      Object.keys(vm.item).map((key) => {
        let formValue = vm.item[key]
        if (['name', 'exclude_outlet_list', 'outlet_group_uuid', 'content', 'parentObj'].includes(key)) {
          formValue = JSON.stringify(vm.item[key])
        }

        formData.append(key, formValue)
      })

      if (vm.id == 'create' || vm.id == undefined) {
        vm.axios.coupon.createExternalCoupon(formData, function(response){
          const errorList = response.data.data.items
          if (errorList != null && errorList.length) {
              vm.$toastr.success(`${vm.$t('message.data_duplicate')} ${errorList.join(',')}.`, vm.$t('message.success'), {})
          } else {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          }
          vm.isProcessing = false
          vm.$bus.$emit('loading', 'none')
          if (vm.item.is_ges) {
            vm.$router.push({name: 'coupon_ges_list'})
          } else {
            vm.$router.push({name: 'coupon_external_list'})
          }
        }, function(e){
          vm.$toastr.error(vm.$t(e.error.code, { row: e.error.data.row }), vm.$t('message.error'), {})
          vm.isProcessing = false
          vm.$bus.$emit('loading', 'none')
          vm.$Progress.finish()
        });
      } else {
        vm.item.sequence = parseInt(vm.item.sequence)
        vm.axios.coupon.updateExternalCoupon(vm.item, function(response){
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.isProcessing = false
          vm.$bus.$emit('loading', 'none')
        }, function(e){
          vm.$toastr.error(vm.$t(e.error.code, { row: e.error.data.row }), vm.$t('message.error'), {})
          vm.isProcessing = false
          vm.$bus.$emit('loading', 'none')
        });
      }
    },
    revertDateFormat (val) {
      let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return this.convertDateTimeToUTC(formatDate)
    },
    convertDateFormat (val) {
      val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    convertDateTimeFormat (val) {
      val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
    },
    mappingCouponData(externalCoupon)
    {
      vm.item.active = externalCoupon.active
      vm.item.addition_number = externalCoupon.addition_number
      vm.item.applicable_active_date_for_user = externalCoupon.applicable_active_date_for_user
      vm.item.client_id = externalCoupon.client_id
      vm.item.code = externalCoupon.code
      vm.item.content = externalCoupon.content || {'en': null}
      vm.item.coupon = externalCoupon.coupon
      vm.item.coupon_id = externalCoupon.coupon_id
      vm.item.created_at = externalCoupon.created_at
      vm.item.crm_url = externalCoupon.crm_url
      vm.item.customer_id = externalCoupon.customer_id
      vm.item.deleted = externalCoupon.deleted
      vm.item.enable_link = externalCoupon.enable_link
      vm.item.exclude_outlet_list = externalCoupon.exclude_outlet_list
      vm.item.id = externalCoupon.id
      vm.item.is_ges = externalCoupon.is_ges
      vm.item.name = externalCoupon.name || {'en': null}
      vm.item.number_of_generate = externalCoupon.number_of_generate
      vm.item.number_of_useage = externalCoupon.number_of_useage
      vm.item.outlet_group_uuid = externalCoupon.outlet_group_uuid
      vm.item.quantity_per_customer = externalCoupon.quantity_per_customer
      vm.item.sequence = externalCoupon.sequence
      vm.item.updated_at = externalCoupon.updated_at
      vm.item.updated_by_email = externalCoupon.updated_by_email
      vm.item.updated_by_id = externalCoupon.updated_by_id
      vm.item.uuid = externalCoupon.uuid
      vm.item.validate_store_name = externalCoupon.validate_store_name
      vm.item.validate_store_url = externalCoupon.validate_store_url
      vm.item.active_start_date=vm.convertDateFormat(externalCoupon.active_from)
      vm.item.active_end_date=vm.convertDateFormat(externalCoupon.active_to)
      vm.item.apply_start_date=vm.convertDateFormat(externalCoupon.apply_from)
      vm.item.apply_end_date=vm.convertDateFormat(externalCoupon.apply_to)

      if (vm.clientID=='606dd890-1e5d-4898-853a-0ef434fff627') {
        vm.item.quantity = externalCoupon.number_of_generate ? externalCoupon.number_of_generate : externalCoupon.number_of_useage
      } else {
        vm.item.quantity = externalCoupon.number_of_useage
      }

      // reload web coupon
      vm.item.parentObj={'text': externalCoupon.coupon.code, 'value': externalCoupon.coupon_id}
    },
    getExternalCouponDetail()
    {
      vm.isLoadingCoupon = true
      if(!vm.id) return

      //get coupon detail
      vm.axios.coupon.getExternalCouponDetail(vm.id, function(response){
        vm.item.sequence = response.data.data.item.coupon.sequence
        let externalCoupon=response.data.data.item
        vm.mappingCouponData(externalCoupon)

        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    getCouponParent () {
      let params = '';
      vm.isLoadingCouponParent = true
      vm.axios.coupon.getCouponParent(params, function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.couponParentData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].code
            item['value'] = response.data.data.items[i].id
            vm.couponParentData[lang].push(item)
          }
        }
        vm.$forceUpdate('couponParentData')
        vm.isLoadingCouponParent = false
        vm.$bus.$emit('loading', 'none')
      })
    },
  },
  created: function () {
    vm = this
    vm.$bus.$emit('loading', 'block')
    vm.getCouponParent()
    vm.getOutletGroups()
    vm.getOutlets()
    vm.getExampleURL()
  },
  updated: function () {
    if (vm.couponParentData[vm.$session.get('lang')]!==undefined) {
      vm.customCouponParentData = vm.couponParentData[vm.$session.get('lang')]
    }
    if (vm.outletGroups[vm.$session.get('lang')]!==undefined) {
      vm.outletGroupsList = vm.outletGroups[vm.$session.get('lang')]
    }
    if (vm.outlets[vm.$session.get('lang')]!==undefined) {
      vm.outletsList = vm.outlets[vm.$session.get('lang')]
    }
    if (vm.id != 'create' && vm.id !== undefined
      && !vm.isLoadingCouponParent
      && !vm.isLoadingOutletGroup
      && !vm.isLoadingOutlet
      && !vm.isLoadingCoupon) {
      vm.getExternalCouponDetail()
    }
  },
  mounted: function(){
  }
}
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }

  .img-min-height {
    min-height: 0 !important;
  }

  /*.multiselect__tags{
    min-height: 35px !important;
    padding: 2px 15px 0px 10px !important;
  }

  .multiselect__select{
    height: 36px !important;
  }

  .multiselect__placeholder{
    margin-bottom: 5px !important;
    padding-top: 4px !important;
  }*/

  .multiselect__placeholder{
    margin-bottom: 6px !important;
  }

  .not_apply_date .mx-input-append {
    display: none!important;
  }
  .not_apply_date .mx-calendar {
    width: 400px!important;
  }
  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .payment-methods{
    padding: 0 !important;
  }

  .payment-methods .form-group{
    padding: 10px 15px 0 15px;
    margin-bottom: 5px;
  }

  .payment-methods .form-group:last-child{
    margin-bottom: 15px;
  }

  .payment-methods .form-check{
    margin-left: 15px;
  }

  .business-hours .form-check{
    padding-right: 15px;
  }

  .business-hours{
    display: inline-flex;
    vertical-align: middle;
  }

  .size-circle{
    margin-left: 5px;
  }

  .sl-discount-unit,
  .ipt-discount-unit{
    min-height: 40px;
  }

  .delete-csv{
    background: transparent;
    color: #0086FF;
    border: none;
    font-size: 20px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store{
    display: inline-flex;
  }

  /*.applicable-store label{
    margin-right: 20px;
  }*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-properties{
    display: -webkit-inline-box;
    position: relative;
    margin: 0;
    padding: 0;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

  .switch-enable-link {
    padding: 0.375rem 0.75rem;
  }

  .upload-text {
    margin-left: 22px;
  }

  .file-upload-text {
    margin-left: 25px;
    margin-right: 5px;
  }

  .upload-icon {
    display: inline-block;
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAYAAACuwEE+AAAAAXNSR0IArs4c6QAABQJJREFUeJzt3T+IHGUcxvHfawQFG0tBUUjhwYGVjXIgYhoLRbG0lCBiJUmRKqhoEeUkFlZiLaLYKVoYUVGwESUQCxWJAeNZSILxCq+4x+JmQszldt9n3nf+7O73AwcHufnNOzPf7O3d7bARuErSy5K2Je02H9uSXhx7XZgYSYckfa2DfSnp0NjrxERI+mBGLK0Px14nJkDS6YxYWqfHXi9GZMZCNKusYyxEs4oKYyGaVVIpFqJZBZLeqBhLa3Ps40IPVPeR5Xo80iyTnmMhmmUyUCxEswwkbQ4YS4vnNItIwz6yXI9HmkUyciwtolkEmkYsLaKZMk0rlhbRTJG6x2L9tbrrPsY+P7hG6YXM/eIa+8LIalzA3A1q7hMjqHXhcjfqY98YiPZesN3Fvl+s5W54g+26/jGTF5YPSdLDHS/UDf935258wLZdHml2JR3p9yzhKklnOlykA78V5A6YsX2XaD7p5+xgH0mXzIsz83lD7pA5M9xofq97VnAgSX/ViqWZVxxMM8eJZqvO2cBckj6rFUszr0owzazcaD4tOwvIJulIrViaedWCaebNi2ZX0iPdjh6dSDo244KcNGdVDaaZeXLGqBe8o0UVktYkvS3pvKRfms/XOsypHkzN9U1JGnsBU5AbQ0pp5c/XTWMvAIuFYGAhGFgIBhaCgYVgYCEYWAgGFoKBhWBgIRhYCAYWgoGFYGDpJRhJT0h6VdLHkrZyX28i6bKk7yQ92se6Fomkx5pzcdk4f1uSPpL0iqTHxz6GuSQdlvStcYCzHB9w3VkGXM+JSufwG0n3DLVui6RnJf1T6UClAW/2yl3QQGvpepPeQa5IemaItWeT9Hzlg2wNcrNX7mIGWkuXm/RyPFdjfcUvOZR0OCLORcSt5cvZ52JK6c4e5v5PbgxDvERT0qWIuL2H0dsRsZ5SulAypOhJr6QUEe9HP7FERKzim1rt9DT3toh4t3RI6U9JGxFxf+kiZvihx9lTdbbH2RuSHigZUBpM0c7nUES83uP8qTrV8/wHSzaecjDHUkqf9zh/klJKZyKiz18pFAVTRNLFys/kf9UIN3vlLm7gNbU3wV2ofI6LnvQWPevPPYlTvwGM48jH35JgIRhYCAYWgoGFYGAhGFgIBhaCgYVgYCEYWAgGFoKBhWBgIRhYCAYWgoGFYGAhGFgIBhaC2fNnpa9ZegSzJ+eGuVW8qW4fgtmzGRG7M/59NyJeG2gty2uK9/N0JenUjEN4aez15Zj89Zj8Ak2S1iW9o713UDvffL4+9rpyDXE9uJFtiQxxPXgOAwvBwEIwsBAMLAQDC8HAQjCwEAwsBAMLwcBCMLAQDCwEAwvBwEIwsBAMLAQDC8HAQjCwEAwsBAMLwcBCMLAQDCwEAwvBwEIwsBAMLAQDC8HAQjCwEAwsBAMLwcBCMLAQDCwEAwvBwEIwsBAMLAQDC8HAQjCwEAwsBAMLwcBCMLAQDCwEA8vNhdtvRcQd875okd7GbwVslWxc+gjDW/Munu9LNiaY1UMwsBQFU/qusrdExNmIuLdkDgbzc0Tcl1L6t+uAokeYZsdPRcROyRwMYiciniyJJaLCj9UppXMRcaJ0Dnp3PKX0Y+mQKr+HSSm9GRFHI+JKjXmo6u+IOJpSeqvGsKrvWC/proh4LyI2as5FZ19ExNMppT9qDawaTEvSWkQ8dM3H3X3sB/v8FhFftR8ppZ9q7+A/06PhlbYtCRsAAAAASUVORK5CYII=');
  }

  .file-icon {
    display: inline-block;
    position: absolute;
    width: 16px;
    height: 16px;
    margin-top: 2px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAYAAACuwEE+AAAAAXNSR0IArs4c6QAABR5JREFUeJzt3LGLnEUcxvFvFESEiIqolQh2EUQwf8BJIiEoQgqLVIKgtYiY0oCggsYohFTiH2BpY0SJBxaCciCCRQohiqJi4A4xEYQ7Ld4t4t3e7Tzvzuxv5p3nA9Pt7jvvO9/svXfZHcjrHuA08CHwDfAjcAP4dyJjC9gAnsp1wXp1GDhP/IKucpzNcuU6dAq4RvwCRox3Mly/rpwBdohfuMhxfumr2ImLxC9WLcPvNAu8TPwi1Tb8TrOPJ4Ft4heoxuFodrmdfm9wHc0IZ4hfkBaG72lmfiV+MVoZ3b/THEW7YB8DjwN3RUw2s7fxO43sTdIv1FtBcyzpHI5Gcpm0C3Q5aoIrMPa/P7r88XSFtItzLGqCK+JoEl0n7cJM4Z5lEUeTIPWi9MLRLOBg9nI0B3Aw8zmafTiY/TmaORzMwRzNLg5mMUdzEweTxtHMOJh0jgYHo+o+Ggej6zoaBzNOt9E4mPG6jMbBLKe7aBzM8rqKxsHk0U00DiafLqJxMHlNPhoHk9+ko3EwZUw2GgdTziSjcTBlTS4aB1PepKJxMKsxmWgczOpMIhoHs1rNRxMdzBrwBbApzCV1bM5ee63g/MdoOprIYM4Kx1921Lb/brPRRAWzJhw71/A7TQZRwawLx8411gucx7KaiyYqmC3h2LnGZoHzyKGpaHoKZqvAeeTSTDRRwfhH0l5NRBMVjG9656s+mqhgoO9fqw9SdTSRwcDwr36dMvc0W7PXbuGdZbdqo4kOxvZXZTQOpm5j9xF+rdSEHEz9xrzT7ADHS0zGwbRhTDSflJiIg2mHGs0vJSbhYNqiRpOdg2mPEk2SQ8LBU19UeU0rL+u63bLERKxDDsYkDsYkDsYkDsYkDsYkDsYkDsYkDsYkDsYkDsYkDsYkLQVzEtigzO4NUWNzdk4nM16nakR9vOFW4A2GjxJGL3CpsQO8PjvX3KLWLezATwjHbnlsU+aztd0Fc0k4duvjUqZrdrOs69bCPcxj0RNYoerPtYVgrCItBPNt9ARWaFLnGnUPc1w4dstjm+EGP7eodYs7MPCecPxWR6ldI7oMBuAI8AFwVZhL7ePq7JyOZLxOu2VdN3/NZPqyrlsLN71WEQdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjEgdjkpaC8e4NjYn61oB3b1hO1LqFHdi7Nyynu2C8e8Nysq5bC/cw1e9okFH159pCMFaRFoKZ1I4GC0zqXKPuYbx7w3Ki1i3uwHj3hmV0GQx494axsq6bd2+Yvqzr1sJNr1XEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZjEwZhECeZ64uPuHzMRK+KBxMf9lfqCSjC/Jz7uUeE1razUbyH8VuLgX5H2ya3PShzcZIeAz0lbsy9TX1R5h9lIfNxx4JzwulbGu8CxxMemrq3kBNrnVa8ALwIPlpiMzfUw8ALDtVfWKjUs6fO3tzHsNnCH8Byr39/AYYavuSyk/Ej6B7g4ZkZWtfdJjAX0T/jfyfDViLvF51md/gAeAm6kPkH9w92fwGmG/UysbTvAswixwLgNbH5g+EPPiRHPtXq8BHy0ygNeIP6bgx7jxoU567kSrzLtrcSmNnaAV+au5AqdAn4m/mJ4HDx+Ap7ZZw1DPM+wv0n0hfH4/9gAnjtg3SQlvjh/H/A0cBR4hGFngnsLHMf2ugZ8D3wHfA18yvCrczb/ARYPIXWjP1qFAAAAAElFTkSuQmCC');
  }

  .remove-icon {
    display: inline-block;
    position: absolute;
    width: 12px;
    height: 12px;
    margin-top: -6px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,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');
  }

  .error-upload {
    color: #EB1112
  }

  .coupon-file-path {
    margin-left: -10px;
    margin-top: 10px; 
    margin-bottom: 10px; 
    display: inline-table;
  }

  .store-file-path {
    margin-left: 10px;
    margin-top: 10px; 
    margin-bottom: 10px; 
    display: inline-table;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/coupon/BaseFormChild.vue